import {computed, ref} from "vue";
import {registrationService} from "@/container";

/**
 * Composable to handle email verification during the registration process.
 */
const useEmailVerification = () => {
    const email = ref<string | undefined>(undefined);
    const emailError = ref<string | undefined>(undefined);
    const alreadyUsedEmail = ref(false);

    /**
     * Determine if the email is valid using a regular expression.
     */
    const isEmailValid = computed(() => {
        return !!email.value &&
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email.value);
    });

    /**
     * Verify the email format and availability by calling the registration service.
     */
    const verifyEmail = async () => {
        if (!isEmailValid.value || !email.value) {
            return;
        }

        const response = await registrationService().isMailAvailable(email.value);
        alreadyUsedEmail.value = !response.success;
        emailError.value = !response.success
            ? 'Un compte existe déjà avec cette adresse e-mail.'
            : undefined;
    };

    return {
        email,
        emailError,
        alreadyUsedEmail,
        isEmailValid,
        verifyEmail
    };
};

export default useEmailVerification;
